// 班级api

import { baseRequest, fileUploadRequest } from './base'

import store from '../vuex'

/**
 * @desc 查询班级列表
 */
function getClassList(params) {
  if (store.getters.schoolId) {
    params = params ? params : {}
    params.schoolId = store.getters.schoolId
  }

  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/pcWeb/teaClass/'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 根据班级ID获取班级信息
 */
function getClassById(id) {
  return baseRequest(`/api/pcWeb/teaClass/${id}`, 'get')
}

/**
 * @desc 新增班级
 */
function addClass(params) {
  if (store.getters.schoolId) {
    params = params ? params : {}
    params.schoolId = store.getters.schoolId
  }
  params = utils.common.checkNull(params)
  return baseRequest(`/api/pcWeb/teaClass/create`, 'post', params)
}

/**
 * @desc 删除班级
 */
function deleteClass(id) {
  return baseRequest(`/api/pcWeb/teaClass/delete/${id}`, 'get')
}

/**
 * @desc 修改班级
 */
function updateClass(id, params) {
  params = utils.common.checkNull(params)
  return baseRequest(`/api/pcWeb/teaClass/update/${id}`, 'post', params)
}

/**
 * @desc 安排老师
 */
function arrangeTeacher(params) {
  return baseRequest(`/api/pcWeb/teaClass/arrangeTeacher`, 'post', params)
}

/**
 * @desc 修改场地
 */
function updatePlace(params) {
  return baseRequest(`/api/pcWeb/teaClass/updatePlace`, 'post', params)
}

/**
 * @desc 确认开班
 */
function confirmClass(id, params) {
  return baseRequest(`/api/pcWeb/teaClass/confirmClass/${id}`, 'post', params)
}

/**
 * @desc 还原预开班
 */
function restoreClass(id, params) {
  return baseRequest(`/api/pcWeb/teaClass/restoreClass/${id}`, 'post', params)
}

/**
 * @desc 取消开班
 */
function cancelClass(id, params) {
  return baseRequest(`/api/pcWeb/teaClass/cancelClass/${id}`, 'post', params)
}
/**
 * @desc 停用班级
 */
function stopUse(id) {
  return baseRequest(`/api/pcWeb/teaClass/disableClass/${id}`, 'post')
}

/**
 * @desc 导出报名学生信息
 */
function excelApplyStudent(id, params) {
  params = utils.common.checkNull(params)
  return fileUploadRequest(
    `/api/pcWeb/teaClass/excelApplyStudent/${id}`,
    params
  )
}

/**
 * @desc 导出退课学生信息
 */
function excelDropStudent(id, params) {
  params = utils.common.checkNull(params)
  return fileUploadRequest(`/api/pcWeb/teaClass/excelDropStudent/${id}`, params)
}

/**
 * @desc 发布 - 预开班
 */
function prepareClass(id) {
  return baseRequest(`/api/pcWeb/teaClass/prepareClass/${id}`, 'post')
}

/**
 * @desc 校验学生人数是否满足
 */
function checkApplyCount(id) {
  return baseRequest(`/api/pcWeb/teaClass/checkApplyCount/${id}`, 'get')
}

/**
 * @desc 插班
 */
function joinClass(params) {
  return baseRequest(`/api/pcWeb/teaClass/joinClass`, 'post', params)
}

/**
 * @desc 查询报班名单
 */
function listApplyStudent(id, params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = `/api/pcWeb/teaClass/listApplyStudent/${id}`
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 查询退班名单
 */
function listDropStudent(id, params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = `/api/pcWeb/teaClass/listDropStudent/${id}`
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 查询可转班级列表
 */
function listCanChangeClass(id) {
  return baseRequest(`/api/pcWeb/teaClass/listCanChangeClass/${id}`, 'get')
}

/**
 * @desc 转班
 */
function changeClass(params) {
  return baseRequest(`/api/pcWeb/teaClass/changeClass`, 'post', params)
}

/**
 * @desc 插班学生删除
 */
function deleteJoinStudent(params) {
  return baseRequest(`/api/pcWeb/teaClass/deleteJoinStudent`, 'post', params)
}

/**
 * @desc 插班学生删除
 */
function quitClass(params) {
  return baseRequest(`/api/pcWeb/teaClass/quitClass`, 'post', params)
}

/**
 * @desc 添加/修改备注
 */
function updateRemark(params) {
  return baseRequest(`/api/pcWeb/teaClass/updateRemark`, 'post', params)
}

/**
 * @desc 班级列表导出
 */
function classExport(params) {
  params = utils.common.checkNull(params)
  return baseRequest(`api/pcWeb/teaClass/export`, 'post', params)
}

/**
 * @desc 批量发布班级
 */
 function batchPrepareClass(params) {
  return baseRequest(`api/pcWeb/teaClass/batchPrepareClass`, 'post', params)
}

/**
 * @desc 批量删除
 */
function batchDeleteClass(params) {
  return baseRequest(`api/pcWeb/teaClass/batchDeleteClass`, 'post', params)
}

/**
 * @desc 批量取消
 */
function batchCancelClass(params) {
  return baseRequest(`api/pcWeb/teaClass/batchCancelClass`, 'post', params)
}


/**
 * @desc 批量开班
 */
function batchOpenClass(params) {
  return baseRequest(`api/pcWeb/teaClass/batchConfirmClass`, 'post', params)
}

/**
 * @desc 批量开班进度条
 */
function batchProgressClass(params) {
  let tempUrl = 'api/pcWeb/teaClass/getConfirmClassStatus'
  return baseRequest(tempUrl, 'get', params)
}



/**
 * @desc 预报名
 */
 function preEnroll(params) {
  return baseRequest(`/api/pcWeb/teaClass/preEnroll`, 'post', params)
}
/**
 * @desc 课时汇总
 */
 function getClassHour(params) {
  params = utils.common.checkNull(params)
  return baseRequest(`/api/pcWeb/report/listClassHourSummary`, 'get', params)
}


export default {
  getClassList: getClassList,
  getClassById: getClassById,
  addClass: addClass,
  deleteClass: deleteClass,
  updateClass: updateClass,
  arrangeTeacher: arrangeTeacher,
  updatePlace: updatePlace,
  confirmClass: confirmClass,
  restoreClass,
  cancelClass: cancelClass,
  excelApplyStudent: excelApplyStudent,
  prepareClass: prepareClass,
  checkApplyCount: checkApplyCount,
  joinClass: joinClass,
  excelDropStudent: excelDropStudent,
  listApplyStudent,
  listDropStudent,
  listCanChangeClass,
  changeClass,
  deleteJoinStudent,
  quitClass,
  updateRemark,
  classExport,
  batchPrepareClass,
  preEnroll,
  batchDeleteClass,
  batchCancelClass,
  batchOpenClass,
  batchProgressClass,
  stopUse,
  getClassHour,
}
